import React from 'react';
export function SectionDivider() {
  return <div className="py-8" data-id="element-442">
      <div className="max-w-7xl mx-auto px-4" data-id="element-443">
        <div className="h-px bg-gray-200 w-full" data-id="element-444"></div>
      </div>
    </div>;
}